export default __webpack_public_path__ + "static/media/fatherIcon.7acd5f46.png";